/* import __COLOCATED_TEMPLATE__ from './suggestion-ai-summary-item.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import type IntlService from 'embercom/services/intl';
import { inject as service } from '@ember/service';
// @ts-expect-error
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';

interface Signature {
  Args: {
    aiSummary: string;
    createdAt: Date;
    onApprove?: () => void;
    onReject?: () => void;
    isUpdating?: boolean;
  };
}

export default class SuggestionAiSummaryItem extends Component<Signature> {
  @service declare intl: IntlService;

  get formattedOverview() {
    let text = this.intl.t(
      'automation.analyze.task-suggestions.api-docs-side-drawer.overview.engineer_review',
    );
    return sanitizeHtml(text);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::SuggestionAiSummaryItem': typeof SuggestionAiSummaryItem;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/suggestion-ai-summary-item': typeof SuggestionAiSummaryItem;
  }
}
